module.exports = __webpack_public_path__ + "static/51-satellite-feb2027-39c555d15bcb5f3a101ad2a4e6c3d53a.jpg";